import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { Home, Docs } from './pages'
import './contrast-api-docs.scss'
import { SpecManifestContextProvider } from './hooks'

export const ContrastApiDocs = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname.endsWith('index.html')) {
      navigate('/')
    }
  }, [navigate, pathname])

  return (
    <SpecManifestContextProvider>
      <div className="api-docs" data-testid="api-docs-app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/*" element={<Docs />} />
        </Routes>
      </div>
    </SpecManifestContextProvider>
  )
}
